import type { Core_CustomFieldFilter } from '@tyro/api';

export const customFieldsKeys = {
  all: ['customFields'] as const,
  customFields: (filter: Core_CustomFieldFilter) =>
    [...customFieldsKeys.all, filter] as const,
};
